
const packageJson = require('../package.json');

export function getVersionString() {
    return packageJson.version;
}

export function getAppName() {
    return `Myslivecký portál`;
}

export function getAppNameWithVersion() {
    return `${getAppName()} v${getVersionString()}`;
}
